import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Params, Router } from '@angular/router';

import { SnAppliance } from '@lib/api/entities';
import { snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-appliance-table',
  templateUrl: './appliance-table.component.html',
  styleUrls: ['./appliance-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snFadeIn, snFadeOut, snListStagger],
})
export class ApplianceTableComponent extends SnTableBaseComponent<SnAppliance> {
  private _displayZeroCounts = false;

  constructor(private readonly _router: Router) {
    super();
  }

  @Input()
  get displayZeroCounts(): boolean {
    return this._displayZeroCounts;
  }
  set displayZeroCounts(value: boolean) {
    this._displayZeroCounts = coerceBooleanProperty(value);
  }

  public trackBy(index: number, item: SnAppliance): any {
    return item.id;
  }

  public onChipClick(appliance: SnAppliance): void {
    const id = appliance.id;
    const queryParams: Params = { exclude_child_cameras: true, appliance: id };
    this._router.navigate(['/cameras/list'], { queryParams });
  }
}
